import React from 'react';
import { Typography } from '@mui/material';

const PortalOnboarding: React.FC = () => {
  return (
    <Typography variant="body1" color="grey.500">
      Coming soon.
    </Typography>
  );
};

export default PortalOnboarding;
